
import { defineComponent } from "vue";
import PlanOrderJournal from "@/components/journals/PlanOrderJournal/PlanOrderJournal.vue";

export default defineComponent({
  components: { PlanOrderJournal },
  props: {
    //модель родительского элемента
    parentModel: { required: true },
    isCalculation: { required: true },
    isSettingsOpen: { required: true },
  },
  methods: {},
  data() {
    return {};
  },
});
